import classnames from 'classnames';
import type { ReactChild, ReactEventHandler } from 'react';

type PaginationButtonProps = {
  children: ReactChild;
  isActive?: boolean;
  isDisabled?: boolean;
  onClick: ReactEventHandler;
};

//  Arrow/button for pagination control
const PaginationButton = ({ children, isActive, isDisabled, onClick }: PaginationButtonProps) => (
  <button
    type="button"
    className={classnames('fossa-pagination__button', {
      'fossa-pagination__button--active': isActive,
    })}
    onClick={onClick}
    disabled={isDisabled}
    data-test-id="pagination-button"
  >
    {children}
  </button>
);

export default PaginationButton;
